<template>
  <div class="home-subscribe-list">
    <action-bar>
      <search placeholder="请输入区块链ID搜索" @onSearch="onSearch"></search>
      <el-button
        v-if="$utils.hasAuth($store, auth.blockchain.suscribeBlockChain.suscribe)"
        type="primary"
        @click="addChain()"
      >
        <div class="subscribe-btn-content">
          <span :class="['iconfont', 'icon-add', 'subscribe-btn-icon']"></span>
          <span class="subscribe-btn-text">
            新增订阅
          </span>
        </div>
      </el-button>
      <div class="fill"></div>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="subscribeList"
        :operator="operator"
        :operate-col="operatorCol"
        :show-edit="true"
        :show-pagination="false"
        :paging="subscribePaging"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="status" slot-scope="{ param }">
          <div class="chain-status">
            <span :class="['chain-status-des', param.row.Healthy ? 'normal' : 'abnormal']">{{
              param.row.Healthy ? '正常' : '异常'
            }}</span>
          </div>
        </template>
        <template slot="chainOrigin" slot-scope="{ param }">
          <div class="chain-origin">
            <span :class="['text', param.row.IsExternal ? 'external' : 'internal']">{{
              param.row.IsExternal ? '平台外创建' : '平台内创建'
            }}</span>
          </div>
        </template>
      </normal-table>
    </common-bg-plate>
    <subscribe-chain
      ref="subscribe"
      :chain-id-options="subscribeList"
      @update:list="getList()"
    ></subscribe-chain>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import subscribeChain from './subscribeChain'
export default {
  name: 'List',
  components: {
    subscribeChain
  },
  data() {
    return {
      // 设置table的列
      tableCol: [
        {
          prop: 'ChainId',
          label: '区块链ID',
          minWidth: 162
        },
        {
          prop: 'Version',
          label: '链版本',
          icon: 'icon-version',
          minWidth: 162
        },
        {
          prop: 'Consensus',
          label: '共识算法',
          minWidth: 162
        },
        {
          prop: 'IsExternal',
          label: '区块链来源',
          slotName: 'chainOrigin',
          minWidth: 162
        },
        {
          prop: 'CreateTime',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 162
        },
        {
          prop: 'Healthy',
          label: '状态',
          slotName: 'status',
          align: 'center',
          headerAlign: 'center',
          minWidth: 162
        },
        {
          prop: 'Summary',
          label: '区块链简介',
          minWidth: 162
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看',
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          icon: 'icon-check',
          class: 'operate-check'
        },
        /*{
          text: '修改',
          click: (row, col, cellValue) => {
            return this.editInfo(row)
          },
          icon: editImg
        },*/
        {
          text: '取消订阅',
          click: (row, col, cellValue) => {
            return this.cancelSubscribe(row)
          },
          formatter: row => {
            return (
              this.$utils.hasAuth(
                this.$store,
                this.auth.blockchain.suscribeBlockChain.unSuscribe
              ) && row.Subscribed
            )
          },
          icon: 'icon-cancel',
          class: 'operate-danger'
        }
      ],
      operatorCol: {
        minWidth: 65
      },
      inputContent: '',
      subscribeList: [],
      auth: auth
    }
  },
  computed: {
    ...mapState({
      // subscribeList: state => state.home.subscribe_list,
      subscribePaging: state => state.home.subscribe_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getSubscribeQueryLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.inputContent,
        chainType: 'anytype' //''/'internal'返回内部链，'external'返回外部链，'anytype'返回内部链和外部链
      }
      this.getSubscribeQueryLists(params).then(res => {
        this.subscribeList = res.items
      })
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    onSearch(val) {
      this.inputContent = val
      this.getList()
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.CreateTime * 1000)
    },
    cancelSubscribe(data) {
      this.$confirm(`确认取消订阅${data.ChainId}区块链？ `, '取消订阅', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$apis.chain.revokeChain({ ChainId: data.ChainId }).then(res => {
            this.$message({
              type: 'success',
              message: '取消订阅成功!'
            })
            this.getList(this.subscribePaging.limit, this.subscribePaging.offset)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '您已放弃取消订阅'
          })
        })
    },
    getInfo(row) {
      if (row.Consensus == 'DPOS') {
        this.$message.info('DPoS共识链暂时不支持查看!')
      } else {
        this.$router.push({
          name: 'chainDetail',
          query: {
            chainId: row.ChainId,
            detail: JSON.stringify(row)
          }
        })
      }
    },
    addChain() {
      this.$refs.subscribe.handleOpen()
    },
    editInfo(val) {
      this.$refs.subscribe.handleOpen(val)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-subscribe-list',
  (
    --home-subscribe-list-operate-check-color: #45c2ff,
    --home-subscribe-list-operate-delete-color: #e95757,
    --home-subscribe-list-status-normal-color: #55da62,
    --home-subscribe-list-status-abnormal-color: #e95757,
    --home-subscribe-list-status-box-background-color: rgba(233, 87, 87, 0.34)
  ),
  (
    --home-subscribe-list-operate-check-color: #45c2ff,
    --home-subscribe-list-operate-delete-color: #e95757,
    --home-subscribe-list-status-normal-color: #55da62,
    --home-subscribe-list-status-abnormal-color: #e95757,
    --home-subscribe-list-status-box-background-color: rgba(233, 87, 87, 0.34)
  )
);
.home-subscribe-list {
  @include adaptation(
    (
      --home-subscribe-list-search-width: 253px,
      --home-subscribe-list-subbtn-icon-fontsize: 16px,
      --home-subscribe-list-subbtn-icon-margin-right: 4px,
      --home-subscribe-list-subbtn-text-fontsize: 12px,
      --home-subscribe-list-subbtn-content-lineheight: 16px,
      --home-subscribe-list-offset: 48px,
      --home-subscribe-list-status-fontsize: 12px,
      --home-subscribe-list-status-box-padding: 2px 8px,
      --home-subscribe-list-status-box-border-radius: 2px
    )
  );
  --home-subscribe-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-subscribe-list-offset)
  );

  .cbaas-action-bar {
    .cbaas-search-wrap {
      width: var(--home-subscribe-list-search-width);
    }

    .subscribe-btn-content {
      display: flex;
      height: var(--home-subscribe-list-subbtn-content-lineheight);
      line-height: var(--home-subscribe-list-subbtn-content-lineheight);

      .subscribe-btn-icon {
        margin-right: var(--home-subscribe-list-subbtn-icon-margin-right);
        font-size: var(--home-subscribe-list-subbtn-icon-fontsize);
      }

      .subscribe-btn-text {
        font-size: var(--home-subscribe-list-subbtn-text-fontsize);
      }
    }
  }

  .common-bg-plate {
    .normal-table-wrap {
      height: 100%;
      min-height: var(--home-subscribe-list-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--home-subscribe-list-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--home-subscribe-list-min-height);

          .chain-status {
            .chain-status-des {
              display: inline-block;
              font-size: var(--home-subscribe-list-status-fontsize);
              padding: var(--home-subscribe-list-status-box-padding);
              border-radius: var(--home-subscribe-list-status-box-border-radius);

              &.normal {
                color: var(--home-subscribe-list-status-normal-color);
              }

              &.abnormal {
                color: var(--home-subscribe-list-status-abnormal-color);
                background: var(--home-subscribe-list-status-box-background-color);
              }
            }
          }

          .operate-item {
            &.operate-check {
              color: var(--home-subscribe-list-operate-check-color);
            }
          }
        }
      }
    }
  }
}
</style>
